import React from 'react';

import css from '../../css/common/loading.module.scss';
import { ReactComponent as Logo } from '../../img/signin/logo.svg';

export const Loading: React.FC = () => (
    <div className={css.wrapper}>
        <Logo height="64" width="275" />
    </div>
);
